import { WeekdayToggle } from '@/domain/termine/components/WeekdayToggle';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import dayjs from 'dayjs';

export function WeekdaySelectFormField({ form }: UpdateTermineFormProps) {
  return (
    <form.Subscribe selector={(state) => state.values.datum}>
      {(datum) => (
        <form.Field name="wochentagAuswahl">
          {(field) => (
            <WeekdayToggle
              date={dayjs(datum)}
              value={field.state.value ?? []}
              onChange={field.handleChange}
            />
          )}
        </form.Field>
      )}
    </form.Subscribe>
  );
}
